import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganisationType } from '@assetaccountant/core/models/enum/organisation-type';
import { OrganisationOnboardingModel } from '@assetaccountant/core/models/onboarding/onboarding-model';
import { StartStatus } from '@assetaccountant/core/models/onboarding/start-status';
import { Register } from '@assetaccountant/core/models/register';
import { RegisterIntegration } from '@assetaccountant/core/models/register-integration';
import { OrganisationResolverResult } from '@assetaccountant/core/resolvers/organisation.resolver';
import { PeriodData, PeriodParams } from '@assetaccountant/core/resolvers/period.resolver';
import { OnboardingService } from '@assetaccountant/core/services/onboarding.service';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import {
  getChildRoute,
  TypedActivatedRouteSnapshot,
} from '@assetaccountant/core/utils/route-utils';
import { TypedNgbModal } from '@assetaccountant/core/utils/typed-modal';
import { getIntegrationName } from '@assetaccountant/integrations/models/integration-type';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-start-banner',
  templateUrl: './start-banner.component.html',
  styleUrls: ['./start-banner.component.scss'],
  standalone: false,
})
export class StartBannerComponent implements OnInit, OnDestroy {
  readonly StartStatus = StartStatus;

  isMinimised = false;
  onboarding?: OrganisationOnboardingModel;
  organisation: OrganisationResolverResult;
  primaryIntegration?: RegisterIntegration;
  register: Register;
  registers: Register[];

  getRegisters$ = this.organisationService
    .listRegisters()
    .pipe(take(1))
    .pipe(tap(({ registers }) => (this.registers = registers)));

  get hasRegisters() {
    return this.register || this.registers?.some(r => !r.isDemo);
  }

  get loading() {
    return !this.registers;
  }

  get integrationName() {
    return this.primaryIntegration?.integrationType
      ? getIntegrationName(this.primaryIntegration.integrationType)
      : null;
  }

  get isNewAndConnectedToPrimaryIntegration() {
    return this.register && this.primaryIntegration;
  }

  get status() {
    if (this.registers === undefined) {
      return StartStatus.Loading;
    }
    if (!this.onboarding) {
      return StartStatus.SetupDepreciation;
    }
    if (this.onboarding.organisationType === OrganisationType.AccountingFirm) {
      return StartStatus.SetupFirm;
    }
    return StartStatus.SetupDepreciation;
  }

  private subscriptions: Subscription[] = [];

  constructor(
    private organisationService: OrganisationService,
    private router: Router,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
    private onboardingService: OnboardingService,
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.onboardingService.getOnboarding().subscribe(result => {
        this.onboarding = result;
      }),
    );

    const { organisation, register } = getChildRoute(
      this.router.routerState.snapshot.root as TypedActivatedRouteSnapshot<
        PeriodParams,
        PeriodData
      >,
    ).data;
    this.register = register;
    this.organisation = organisation;

    this.subscriptions.push(this.getRegisters$.subscribe());
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
